app.directive('terytmultiple', function($timeout) {
    return {
        restrict: 'E',
        scope: {
            tmCounty: '=',
            tmComunity: '=',
            tmStreet: '=',
            tmCity: '=',
        },
        templateUrl: "/assets/js/angular/components/directives/terytmultiple/terytmultiple.html",
        link: function(scope) {

        }
    };
});
